export default __webpack_public_path__ + "static/media/email.7c446e29.png";